var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var SocialTwitter16 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '16px' : _c, _d = _a.width, width = _d === void 0 ? '16px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 16 16", style: svgStyle },
            React.createElement("path", { d: "M14 4.184a4.822 4.822 0 01-1.414.397 2.527 2.527 0 001.083-1.396 4.861 4.861 0 01-1.564.611A2.433 2.433 0 0010.308 3c-1.36 0-2.462 1.13-2.462 2.524 0 .198.022.39.064.575-2.046-.105-3.86-1.11-5.075-2.637a2.564 2.564 0 00-.333 1.27c0 .875.434 1.648 1.096 2.1a2.399 2.399 0 01-1.115-.315l-.001.031c0 1.224.85 2.242 1.975 2.475a2.402 2.402 0 01-1.112.044c.314 1.002 1.222 1.732 2.3 1.753A4.863 4.863 0 012 11.865 6.842 6.842 0 005.774 13c4.529 0 7.005-3.847 7.005-7.183 0-.11-.003-.218-.007-.327.48-.356.898-.8 1.228-1.306", fillRule: "evenodd" }))));
};
SocialTwitter16.displayName = 'SocialTwitter16';
export default SocialTwitter16;
//# sourceMappingURL=social-twitter-16.js.map